import { Component, OnInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { DashboardClaimsService } from './dashboard-claims.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { IMyDrpOptions } from 'mydaterangepicker';
import { _currencyFormat } from 'app/utils/trip2-query-builder/utils/helpers';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-dashboard-claims',
  templateUrl: './dashboard-claims.component.html',
  styleUrls: ['./dashboard-claims.component.scss']
})
export class DashboardClaimsComponent implements OnInit {

  gridClaims: GridOptions;
  dateRange: any;
  pickerOptions: IMyDrpOptions = {
    dateFormat: 'yyyy-mm-dd',
    markCurrentDay: true,
    editableDateRangeField: false
  };
  private myCellRenderer = function(params) {
    return _currencyFormat(params.value ? params.value : 0);
  };

  constructor(
    private service: DashboardClaimsService,
    private loading: T2LoadingService,
    private toastrAlertHelper: ToastrAlertHelper) {

    this.gridClaims = <GridOptions> {};
    this.gridClaims.columnDefs = this.defineColumnsGrid();

    // TODO Cargar Grid Vacia
    this.gridClaims.onGridReady = () => {
      this.gridClaims.api.setRowData([]);
    };
  }

  ngOnInit() {

  }

  onGridReady(event) {
    event.api.sizeColumnsToFit();
  }

  private getClaims(start, end) {
    this.loading.show();
    this.service.getClaimsByRange(start, end).finally( () => {
      this.loading.hiden();
    }).subscribe(
      (resp) => {
        this.gridClaims.api.setRowData(resp);
      },
      (err) => {
        this.toastrAlertHelper.error(err.message);
      });
  }

  /**
   * @description this execute when user change date
   * @name onSelectRangeDate
   * @param event
   */
  public onSelectRangeDate(event) {
    if (event) {
      const splitRangeDate = event.formatted.split(' - ');
      if (splitRangeDate.length > 1) {
        this.getClaims(splitRangeDate[0], splitRangeDate[1]);
      }
    }
  }

  /**
   * @name defineColumnsGrid
   * @description Define grid Columns
   */
  private defineColumnsGrid() {
    return [ {
      headerName: 'Company',
      field: 'company',
      colId: 'company',
      width: 350
    }, {
      headerName: 'None',
      children: [{
        headerName: 'Trips',
        field: 'none',
        colId: 'none',
        width: 119,
        cellClass: ['text-a-right']
      },
        {
          headerName: 'Amount',
          field: 'totalnone',
          colId: 'totalnone',
          width: 150,
          cellClass: ['text-a-right'],
          cellRenderer: this.myCellRenderer
        }
      ]
    }, {
      headerName: 'Unbilled',
      children: [{
        headerName: 'Trips',
        field: 'unbilled',
        colId: 'unbilled',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalunbilled',
        colId: 'totalunbilled',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Unpaid',
      children: [{
        headerName: 'Trips',
        field: 'unpaid',
        colId: 'unpaid',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalunpaid',
        colId: 'totalunpaid',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Approved',
      children: [{
        headerName: 'Trips',
        field: 'approved',
        colId: 'approved',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalapproved',
        colId: 'totalapproved',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Processed',
      children: [{
        headerName: 'Trips',
        field: 'processed',
        colId: 'processed',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalprocessed',
        colId: 'totalprocessed',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Paid',
      children: [{
        headerName: 'Trips',
        field: 'paid',
        colId: 'paid',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalpaid',
        colId: 'totalpaid',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Rejected',
      children: [{
        headerName: 'Trips',
        field: 'rejected',
        colId: 'rejected',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totalrejected',
        colId: 'totalrejected',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Denied',
      children: [{
        headerName: 'Trips',
        field: 'denied',
        colId: 'denied',
        width: 119,
        cellClass: ['text-a-right']
      },
      {
        headerName: 'Amount',
        field: 'totaldenied',
        colId: 'totaldenied',
        width: 150,
        cellClass: ['text-a-right'],
        cellRenderer: this.myCellRenderer
      }
    ]
    }, {
      headerName: 'Total',
        children: [{
            headerName: 'Trips',
            field: 'total',
            colId: 'total',
            width: 150,
            cellClass: ['text-a-right']
          },
          {
            headerName: 'Amount',
            field: 'totalprovideramount',
            colId: 'totalprovideramount',
            width: 150,
            cellClass: ['text-a-right'],
            cellRenderer: this.myCellRenderer
          }
        ]
    }
  ];
  }

  /**
   * @name removeSort
   * @description remove all sort in the grid
   */
  removeSort() {
    this.gridClaims.api.setSortModel(null);
  }

  /**
   * @name clearFilter
   * @description this clear all filter in the grid
   */
  clearFilter() {
    this.gridClaims.api.setFilterModel(null);
    this.gridClaims.api.deselectAll();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/dashboard-claims/dashboard-claims.component.ts